// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZtGrf","title":"styles_title__c6mXU","text":"styles_text__yguoM"};